<template>
    <message-hub-sidebar-row
        :active="active"
        :selected="undefined"
        :to="{
            name: 'message-hub.scheduled-message',
            params: {
                scheduledMessageId: props.message.id,
            },
        }"
        data-test="scheduled-message-item"
    >
        <template v-slot:title>
            {{ contactTitle }}
        </template>

        <template v-slot:date>
            {{ fromNow(props.message.send_at) }}
        </template>

        <template v-slot:content>
            {{ props.message.body }}
        </template>

        <template v-if="props.message.user !== undefined" v-slot:badges>
            <vx-badge size="xs" :color="active ? 'primary' : 'slate'">
                {{ props.message.user.name }}
                <font-awesome-icon widthAuto :icon="faComment" :class="[active ? 'text-sky-500' : 'text-slate-500']" />
            </vx-badge>
        </template>
    </message-hub-sidebar-row>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { displayContactName } from '~/components/filters';
import { fromNow } from '~/utils/date';
import MessageHubSidebarRow from '../message-hub-sidebar/MessageHubSidebarRow.vue';
import { faComment } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge } from '@voxie/frontend-components';

const route = useRoute();

const props = defineProps({
    message: {
        type: Object,
        required: true,
    },
});

const active = computed(() => Number(route.params.scheduledMessageId) === props.message.id);
const contactTitle = computed(() => displayContactName(props.message.contact));
</script>
